import { Controller } from "@hotwired/stimulus";

// GO4TEACH « Créer une évaluation » (lot 10): the chapters ticked — the locked ones (not yet
// studied) only once the lock is lifted —, the points of each exercise and the watched total
// on 20, the teacher / student preview. « Générer » waits for a chapter and a total of 20.
export default class extends Controller {
  static targets = ["chapter", "unlock", "count", "points", "pointsLabel", "total", "totalNote",
    "submit", "teacherOnly", "studentOnly", "previewButton", "blocked"];
  static values = {
    total: { type: Number, default: 20 },
    // Lot 11: on a document, its chapters are the document's — none to tick.
    document: { type: Boolean, default: false },
    chaptersOne: String, chaptersOther: String,
    complete: String, missingOne: String, missingOther: String, overOne: String, overOther: String,
    pointsOne: String, pointsOther: String,
  };

  connect() {
    this.lock();
    this.refresh();
  }

  // Lifting the lock opens the chapters not studied; putting it back unticks them.
  lock() {
    const open = this.hasUnlockTarget && this.unlockTarget.checked;
    this.chapterTargets.forEach((box) => {
      if (box.dataset.studied === "true") return;
      box.disabled = !open;
      if (!open) box.checked = false;
      box.closest("[data-g4t-chapter]")?.classList.toggle("is-locked", !open);
    });
    this.refresh();
  }

  more(event) { this.move(event, 1); }

  less(event) { this.move(event, -1); }

  move(event, step) {
    const index = Number(event.currentTarget.dataset.index);
    const input = this.pointsTargets[index];
    input.value = Math.max(0, Math.min(this.totalValue, Number(input.value) + step));
    this.refresh();
  }

  preview(event) {
    const student = event.currentTarget.dataset.view === "student";
    this.teacherOnlyTargets.forEach((el) => { el.hidden = student; });
    this.studentOnlyTargets.forEach((el) => { el.hidden = !student; });
    this.previewButtonTargets.forEach((button) => {
      button.setAttribute("aria-selected", String(button === event.currentTarget));
    });
  }

  refresh() {
    const chapters = this.chapterTargets.filter((box) => box.checked).length;
    if (this.hasCountTarget) {
      this.countTarget.textContent = this.plural(chapters, this.chaptersOneValue, this.chaptersOtherValue);
    }
    const total = this.pointsTargets.reduce((sum, input) => sum + Number(input.value || 0), 0);
    this.pointsTargets.forEach((input, index) => {
      const label = this.pointsLabelTargets.filter((el) => Number(el.dataset.index) === index);
      label.forEach((el) => { el.textContent = this.plural(Number(input.value), this.pointsOneValue, this.pointsOtherValue); });
    });
    this.totalTargets.forEach((el) => { el.textContent = `${total} / ${this.totalValue}`; });
    const gap = this.totalValue - total;
    let note = this.completeValue;
    if (gap > 0) note = this.plural(gap, this.missingOneValue, this.missingOtherValue);
    if (gap < 0) note = this.plural(-gap, this.overOneValue, this.overOtherValue);
    this.totalNoteTargets.forEach((el) => {
      el.textContent = note;
      el.dataset.complete = String(gap === 0);
    });
    const ready = (this.documentValue || chapters > 0) && gap === 0;
    if (this.hasSubmitTarget) this.submitTarget.disabled = !ready;
    this.blockedTargets.forEach((el) => {
      const covered = this.documentValue || chapters > 0;
      el.hidden = el.dataset.reason === "chapters" ? covered : (!covered || gap === 0);
    });
  }

  plural(count, one, other) {
    return (count === 1 ? one : other).replace("%{count}", count);
  }
}
